export const getMeasurementMasterList = state => {
    return state.list
}

export const getMeasurementMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementMaster/getters.js